import { render, staticRenderFns } from "./gestionliquidacion.vue?vue&type=template&id=c4086690"
import script from "./gestionliquidacion.vue?vue&type=script&lang=js"
export * from "./gestionliquidacion.vue?vue&type=script&lang=js"
import style0 from "./gestionliquidacion.vue?vue&type=style&index=0&id=c4086690&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports